import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Box,
  Paper,
  Divider,
} from "@mui/material";
import { OrderHistoryApi } from "../../Utility/UtilApi/UtilApi"; // Adjust path as needed
import UtilToastMessages from "../../Utility/UtilToastMessages/UtilToastMessages";
import { useStore } from "../StoreContext/StoreContext";


function OrderHistoryPage() {
  const [orderHistory, setOrderHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSnackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastColor, setToastColor] = useState("");
    
    const [currencyCode, setCurrencyCode] = useState("")
const { 
    hasExistingOrder, 
    OrderRecordId, 
    dealLineItems,
    fetchCurrentDeals,
    updateDealState,
  } = useStore();
  // Fetch order history on mount
  useEffect(() => {
    fetchOrderHistory();
  }, []);

  console.log("currencyCode",currencyCode);
  
    
     useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on mount
      }, []);

  const fetchOrderHistory = async () => {
    try {
      const payload = { order: "history" };
      const response = await OrderHistoryApi(payload);
      console.log("OrderHistoryApi response:", response);
      setCurrencyCode(response?.data?.currencycode);

      // Extract orders from response.data.orders
      const orders = Array.isArray(response.data.orders) ? response.data.orders : [];
      setOrderHistory(orders);
    //   setToastMessage(response.message || "Order history loaded successfully!");
    //   setToastColor("success");
    //   setSnackbarOpen(true);
    } catch (error) {
      console.error("Error fetching order history:", error);
      setToastMessage(error.response?.data?.message || "Failed to load order history.");
      setToastColor("");
      setSnackbarOpen(true);
      setOrderHistory([]);
    } finally {
      setLoading(false);
    }
  };

  // Handlers for toast
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  return (
    <Container sx={{ padding: "20px", fontFamily: "Poppins, sans-serif", mt: 20 }}>
      <Typography
        variant="h4"
        gutterBottom
        sx={{ fontWeight: "bold", mb: 4, color: "#6b5b8e" }}
      >
        Order History
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress size={60} sx={{ color: "#8c7aa2" }} />
        </Box>
      ) : orderHistory.length === 0 ? (
        <Typography
          variant="h6"
          sx={{ textAlign: "center", color: "#555", mt: 4 }}
        >
          No order history found.
        </Typography>
      ) : (
        <List>
          {orderHistory.map((order, index) => (
            <Paper
              key={order.id || order.recordid}
              elevation={3}
              sx={{
                mb: 2,
                borderRadius: 2,
                overflow: "hidden",
                background: "linear-gradient(135deg, #ffffff 0%, #f5f5f5 100%)",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              }}
            >
              <ListItem
                sx={{
                  p: 2,
                  "&:hover": { backgroundColor: "#f9f9f9" },
                }}
              >
                <ListItemText
                  primary={
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: "bold", color: "#6b5b8e" }}
                    >
                      {order.name}
                    </Typography>
                  }
                  secondary={
                    <Box sx={{ mt: 1 }}>
                      {/* <Typography
                        variant="body2"
                        sx={{ color: "#333", mb: 0.5 }}
                      >
                        <strong>Type:</strong> {order.type || "N/A"}
                      </Typography> */}
                      {/* <Typography
                        variant="body2"
                        sx={{ color: "#333", mb: 0.5 }}
                      >
                        <strong>Stage:</strong> {order.stage || "N/A"}
                      </Typography> */}
                      {/* <Typography
                        variant="body2"
                        sx={{ color: "#333", mb: 0.5 }}
                      >
                        <strong>Client Contact:</strong> {order.clientcontact || "N/A"}
                      </Typography> */}
                      <Typography
                        variant="body2"
                        sx={{ color: "#333", mb: 0.5 }}
                      >
                        <strong> Amount:</strong>{" "}
                        {order.dealamount
                          ? `${currencyCode}${order.dealamount.toFixed(2)}`
                          : "N/A"}
                      </Typography>
                      {/* <Typography
                        variant="body2"
                        sx={{ color: "#333", mb: 0.5 }}
                      >
                        <strong>Created Date:</strong> {order.createddate || "N/A"}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "#333" }}
                      >
                        <strong>Last Modified:</strong> {order.lastmodifieddate || "N/A"}
                      </Typography> */}
                    </Box>
                  }
                />
              </ListItem>
              {/* Line Items (optional detail section) */}
              {order.deallineitems && order.deallineitems.length > 0 && (
                <>
                  <Divider />
                  <Box sx={{ p: 2 }}>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: "bold", color: "#8c7aa2", mb: 1 }}
                    >
                      Order Items
                    </Typography>
                    {order.deallineitems.map((item) => (
                      <Box
                        key={item.id || item.recordid}
                        sx={{ mb: 1, pl: 2 }}
                      >
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>Product:</strong> {item.name || "N/A"}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>Quantity:</strong> {item.quantity || "N/A"}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>Total:</strong>{" "}
                          {item.lineitemtotal
                            ? `${currencyCode}${item.lineitemtotal.toFixed(2)}`
                            : "N/A"}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </>
              )}
            </Paper>
          ))}
        </List>
      )}

      {/* Toast Notification */}
      <UtilToastMessages
        isOpen={isSnackbarOpen}
        handleClose={handleSnackbarClose}
        data={toastMessage}
        severity={toastColor}
      />
    </Container>
  );
}

export default OrderHistoryPage;